'use strict'

module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 31
// module chunks = 0